import { notification_color_keys } from "utils/hooks";
import { fileTypeIsAnyOfMIMETypes } from "utils/fileUtils";
import { logError } from "utils/error";
import { is_empty } from "features/Common/utils/common.utils";
import {
  all_formats_dispute_documents,
  max_uploadable_file_size_in_mb,
  max_uploadable_files_limit,
} from "../InitiateDisputeModal.constants";
import { uploadMedia } from "features/Common/modules/MediaUpload/MediaUpload.utils";
import { getS3SignedUrl } from "features/Common/modules/S3/utils/S3.utils";

const fileSizeIsValid = (file = {}) => {
  const fileSizeInMB = (file.size || 0) / (1024 * 1024);
  return fileSizeInMB <= max_uploadable_file_size_in_mb;
};
const checkAndUpdateValidFiles = (files = [], notify) => {
  let validFiles = [];
  if (!is_empty(files)) {
    if (files.length > max_uploadable_files_limit) {
      notify(
        `Max allowed file upload limit is ${max_uploadable_files_limit}`,
        notification_color_keys.info
      );
      let removedFiles = files.splice(5);
      let removedFileNames = removedFiles
        .map((removedFile) => {
          return removedFile.name;
        })
        .join(", ");
      notify(
        `${removedFileNames} are removed due to exceeding file count`,
        notification_color_keys.info
      );
    }
    files.forEach((file) => {
      if (!fileSizeIsValid(file)) {
        notify(
          `Files with size greater than ${max_uploadable_file_size_in_mb}MB are not allowed.`,
          notification_color_keys.info
        );
        notify(
          `${file.name} is removed due to exceeding size`,
          notification_color_keys.info
        );
        return;
      }
      if (!fileTypeIsAnyOfMIMETypes(file.type, all_formats_dispute_documents)) {
        notify(
          `Files with ${file.type} is not allowed to be uploaded.`,
          notification_color_keys.info
        );
        notify(
          `${file.name} is removed due non allowed format`,
          notification_color_keys.info
        );
        return;
      }
      validFiles.push(file);
    });
  }
  return validFiles;
};

export const uploadAndAddDocsOrImgToMediaLib = async ({
  files: filesProp = [],
  existingFiles,
  notify,
  updateFiles: updateUploadingListProp = () => {},
  setLoading,
  callInitiatedFrom,
}) => {
  const files = checkAndUpdateValidFiles(filesProp, notify);
  let updatedFilesWithUploadedUrl = [];

  for (let file of files) {
    let fileToUpload = file;
    if (file?.name.includes(" ")) {
      const sanitizedName = file?.name.trim().replace(/\s+/g, "_");
      fileToUpload = new File([file], sanitizedName, { ...file });
    }

    if (!file?.isUploaded) {
      await uploadMedia({
        file: fileToUpload,
        sectionName: "disputes",
        isPublic: false,
      })
        .then((uploadToS3ApiResponse) => {
          const fileLocation = uploadToS3ApiResponse?.fileUrl;
          if (fileLocation) {
            let updatedFile = fileToUpload;
            updatedFile.fileLocation = fileLocation;
            updatedFile.isUploaded = true;
            updatedFilesWithUploadedUrl.push(updatedFile);
          } else {
            throw new Error(
              `uploadToS3ApiResponse.Location not found. uploadToS3ApiResponse: ${JSON.stringify(
                uploadToS3ApiResponse
              )};`
            );
          }
        })
        .catch((err) => {
          logError({
            err,
            occuredAt: `callInitiatedFrom: ${callInitiatedFrom} at src/ui/pages/transactions/AllTransaction/components/InitiateDisputeModal/utils/InitiateDisputeModal.utils.js`,
            when: "calling uploadAndAddDocsOrImgToMediaLib",
          });
        });
    }
  }
  updateUploadingListProp([...updatedFilesWithUploadedUrl, ...existingFiles]);
  setLoading(false);
};

export const getSignedS3DownlaodURL = async (record, source) => {
  if (is_empty(record?.[source])) return;
  const newUrl = new URL(record?.[source]);
  const { pathname: PdfFile = "" } = newUrl;
  // substring(1) for removing "/" comes in pathname
  const url = await getS3SignedUrl({
    bucket: process.env.REACT_APP_S3_ATTACHMENT_BUCKET,
    key: PdfFile.substring(1),
  });
  if (url) window.open(url);
};
